import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Link } from "react-scroll";
import "./index.scss";

const Navbar = () => {
  return (
    <nav>
      <h3 className="logo">{`<Pitaz />`}</h3>
      <Router>
        <ul>
          <Link
            to="jumbo-header"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active-link"
          >
            About
          </Link>
          <Link
            to="project"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active-link"
          >
            Projects
          </Link>
          <Link
            to="experience"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            activeClass="active-link"
          >
            Stack
          </Link>
          <Link to="/#">Blog</Link>
        </ul>
      </Router>
    </nav>
  );
};

export default Navbar;
